import React from 'react';
import { Menu, Sun, Moon } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';
import useAuthStore from '@/stores/authStore';

interface MobileHeaderProps {
  onMenuClick: () => void;
  title?: string;
}

export function MobileHeader({ onMenuClick, title }: MobileHeaderProps) {
  const { theme, setTheme } = useTheme();
  const { user } = useAuthStore();

  return (
    <header className="lg:hidden fixed top-0 left-0 right-0 h-16 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 z-30 px-4 flex items-center justify-between shadow-sm">
      {/* Hamburger button */}
      <button
        onClick={onMenuClick}
        className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
        aria-label="Abrir menú"
      >
        <Menu className="w-6 h-6 text-gray-600 dark:text-gray-300" />
      </button>

      {/* Logo and title */}
      <div className="flex items-center space-x-2 flex-1 justify-center">
        <img
          src="/logo.png"
          alt="MundiRep"
          className="w-8 h-8 object-contain"
        />
        {title && (
          <h1 className="text-lg font-bold text-gray-900 dark:text-white truncate max-w-[150px]">
            {title}
          </h1>
        )}
      </div>

      {/* Theme toggle */}
      <button
        onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
        className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
        title="Cambiar tema"
        aria-label="Cambiar tema"
      >
        {theme === 'dark' ? (
          <Sun className="w-5 h-5 text-gray-600 dark:text-gray-300" />
        ) : (
          <Moon className="w-5 h-5 text-gray-600 dark:text-gray-300" />
        )}
      </button>
    </header>
  );
}

export default MobileHeader;
